// extracted by mini-css-extract-plugin
export default {"rotate3d":"Icons_rotate3d__jwL4p","rotateAnimation":"Icons_rotateAnimation__nR05x"};